import '../modules/cart/scss/style.scss'
import { initCart } from "../modules/cart";

initCart();
